export const CONTACT_CUSTOMER_DRAWER_MODAL_NAME =
  'orders.contact_customer_drawer_'
